<template>
  <b-row class="base-row-padded">
    <b-col>
      <b-button variant="light" :to="{name: 'users'}"> &lt; Back to Users</b-button>
      <h2>User profile</h2>
      <b-form @submit.prevent="handleSubmit" v-if="user">

        <b-form-group label="Name:">
          <b-form-input v-model="user.name" required placeholder="Name"/>
          <b-form-invalid-feedback
            v-if="formErrors && formErrors.name && formErrors.name.length > 0" :state="false">
            <p v-for="(e, $index) in formErrors.name" :key="$index">{{e}}</p>
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Email:">
          <b-form-input v-model="user.email" type="email" required placeholder="Email"/>
          <b-form-invalid-feedback
            v-if="formErrors && formErrors.email && formErrors.email.length > 0" :state="false">
            <p v-for="(e, $index) in formErrors.email" :key="$index">{{e}}</p>
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Phone:">
          <b-form-input v-model="user.phone" placeholder="Number"/>
          <b-form-invalid-feedback
            v-if="formErrors && formErrors.phone && formErrors.phone.length > 0" :state="false">
            <p v-for="(e, $index) in formErrors.phone" :key="$index">{{e}}</p>
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Role:">
          <b-form-select v-model="user.role" required>
            <option v-for="(value, $index) in userRoles" :value="$index" :key="$index">{{value}}</option>
          </b-form-select>
        </b-form-group>

        <b-row>
          <b-col>
            <b-button class="mr-2" type="submit" variant="success" :disabled="formLoading" v-if="id === 'new'">Save</b-button>
            <b-button class="mr-2" type="submit" variant="success" :disabled="formLoading" v-if="id !== 'new'">Update</b-button>
            <b-button class="mr-2" variant="danger" @click="deleteUserProxy" :disabled="formLoading">Delete</b-button>
            <b-spinner v-show="formLoading" small label="Small Spinner"></b-spinner>
          </b-col>
        </b-row>

        <b-alert class="mt-3" :show="this.formError && this.formError.length > 0"
          variant="danger" dismissible>
          {{ this.formError }}
        </b-alert>

      </b-form>
    </b-col>
  </b-row>
</template>

<script>
import axios from '@/modules/axiosInterceptor';
import { apiUrlPrefix } from '@/modules/staticData';
import formsMixin from '@/mixins/forms';
import rolesMixin from '@/modules/rolesMixin';
import usersMixin from './usersMixin';

export default {
  mixins: [formsMixin, rolesMixin, usersMixin],
  data() {
    return {
      user: null,
    };
  },
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
    userObj: {
      type: [Object],
      required: false,
    },
  },
  created() {
    if (this.id !== 'new') {
      this.getUser();
    } else {
      this.user = {
        email: '',
        name: '',
        phone: '',
        role: '',
      };
    }
  },
  methods: {
    getUser() {
      if (!this.userObj) {
        axios.get(`${apiUrlPrefix}users/${this.id}`).then(
          (r) => {
            this.user = r.data.user;
            this.user.role = this.user.role.id;
          },
        );
      } else {
        this.user = this.userObj;
        this.user.role = this.user.role.id;
      }
    },
    handleSubmit() {
      if (this.id === 'new') {
        this.createUser(this.user)
          .then(() => {})
          .catch(() => {});
      } else {
        this.updateUser(this.user)
          .then(() => {})
          .catch(() => {});
      }
    },
    deleteUserProxy() {
      this.deleteUser(this.user).then(() => {
        this.$router.push({ name: 'users' });
      });
    },
  },
};
</script>
